// This file is auto-generated by @hey-api/openapi-ts

import { z } from 'zod';

export const zCreatePlayerPositionDto = z.object({
    title: z.string()
});

export const zAugmentedZodDto = z.object({
    success: z.boolean(),
    statusCode: z.number(),
    message: z.string(),
    errors: z.record(z.unknown()).optional()
});

export const zUpdateResultDto = z.object({
    success: z.boolean(),
    data: z.enum(['OK'])
});

export const zPaginationPlayerPositionResult = z.object({
    success: z.boolean(),
    data: z.object({
        items: z.array(z.object({
            id: z.number(),
            title: z.string()
        })),
        page: z.object({
            total: z.number(),
            skip: z.number(),
            limit: z.number()
        })
    })
});

export const zPlayerPositionResultDto = z.object({
    success: z.boolean(),
    data: z.object({
        id: z.number(),
        title: z.string()
    })
});

export const zInvitesPaginationResult = z.object({
    success: z.boolean(),
    data: z.object({
        items: z.array(z.object({
            firstName: z.string(),
            lastName: z.string(),
            email: z.string().email(),
            role: z.enum([
                'DEVELOPER',
                'EDITOR',
                'ADMIN'
            ]),
            id: z.number(),
            expiresAt: z.string().datetime(),
            createdAt: z.string().datetime()
        })),
        page: z.object({
            total: z.number(),
            skip: z.number(),
            limit: z.number()
        })
    })
});

export const zCreateInviteDto = z.object({
    firstName: z.string(),
    lastName: z.string(),
    email: z.string().email(),
    role: z.enum([
        'DEVELOPER',
        'EDITOR',
        'ADMIN'
    ]),
    scopes: z.array(z.string()).optional().default([])
});

export const zGetInviteResultDto = z.object({
    success: z.boolean(),
    data: z.object({
        id: z.number(),
        completed: z.boolean(),
        metadata: z.object({
            name: z.string()
        }),
        expired: z.boolean()
    })
});

export const zGetQrCodeResultDto = z.object({
    success: z.boolean(),
    data: z.object({
        qrCode: z.string()
    })
});

export const zInviteCompleteDto = z.object({
    password: z.string(),
    code: z.string()
});

export const zPaginationTournamentResultDto = z.object({
    success: z.boolean(),
    data: z.object({
        items: z.array(z.object({
            id: z.number(),
            parentTournamentId: z.union([
                z.number(),
                z.null()
            ]),
            type: z.enum([
                'table',
                'group',
                'cup'
            ]),
            title: z.string(),
            about: z.union([
                z.string(),
                z.null()
            ]).optional(),
            withExtraPointsOnGameDraw: z.boolean(),
            with10mPenalty: z.boolean(),
            photos: z.union([
                z.array(z.object({
                    id: z.number(),
                    tournamentId: z.union([
                        z.number(),
                        z.null()
                    ]),
                    url: z.string(),
                    storageKey: z.string(),
                    createdAt: z.string()
                })),
                z.null()
            ]).optional(),
            publishedAt: z.union([
                z.string(),
                z.null()
            ]),
            startedAt: z.string().optional(),
            archivedAt: z.union([
                z.string(),
                z.null()
            ]),
            parentTournament: z.union([
                z.object({
                    id: z.number(),
                    parentTournamentId: z.union([
                        z.number(),
                        z.null()
                    ]),
                    type: z.enum([
                        'table',
                        'group',
                        'cup'
                    ]),
                    title: z.string(),
                    about: z.union([
                        z.string(),
                        z.null()
                    ]).optional(),
                    withExtraPointsOnGameDraw: z.boolean(),
                    with10mPenalty: z.boolean(),
                    photos: z.union([
                        z.array(z.object({
                            id: z.number(),
                            tournamentId: z.union([
                                z.number(),
                                z.null()
                            ]),
                            url: z.string(),
                            storageKey: z.string(),
                            createdAt: z.string()
                        })),
                        z.null()
                    ]).optional(),
                    publishedAt: z.union([
                        z.string(),
                        z.null()
                    ]),
                    startedAt: z.string().optional(),
                    archivedAt: z.union([
                        z.string(),
                        z.null()
                    ])
                }),
                z.null()
            ]).optional(),
            childrenTournaments: z.union([
                z.array(z.object({
                    id: z.number(),
                    parentTournamentId: z.union([
                        z.number(),
                        z.null()
                    ]),
                    type: z.enum([
                        'table',
                        'group',
                        'cup'
                    ]),
                    title: z.string(),
                    about: z.union([
                        z.string(),
                        z.null()
                    ]).optional(),
                    withExtraPointsOnGameDraw: z.boolean(),
                    with10mPenalty: z.boolean(),
                    photos: z.union([
                        z.array(z.object({
                            id: z.number(),
                            tournamentId: z.union([
                                z.number(),
                                z.null()
                            ]),
                            url: z.string(),
                            storageKey: z.string(),
                            createdAt: z.string()
                        })),
                        z.null()
                    ]).optional(),
                    publishedAt: z.union([
                        z.string(),
                        z.null()
                    ]),
                    startedAt: z.string().optional(),
                    archivedAt: z.union([
                        z.string(),
                        z.null()
                    ])
                })),
                z.null()
            ]).optional()
        })),
        page: z.object({
            total: z.number(),
            skip: z.number(),
            limit: z.number()
        })
    })
});

export const zTournamentWithAwardsResultDto = z.object({
    success: z.boolean(),
    data: z.object({
        id: z.number(),
        parentTournamentId: z.union([
            z.number(),
            z.null()
        ]),
        type: z.enum([
            'table',
            'group',
            'cup'
        ]),
        title: z.string(),
        about: z.union([
            z.string(),
            z.null()
        ]).optional(),
        withExtraPointsOnGameDraw: z.boolean(),
        with10mPenalty: z.boolean(),
        photos: z.union([
            z.array(z.object({
                id: z.number(),
                tournamentId: z.union([
                    z.number(),
                    z.null()
                ]),
                url: z.string(),
                storageKey: z.string(),
                createdAt: z.string()
            })),
            z.null()
        ]).optional(),
        publishedAt: z.union([
            z.string(),
            z.null()
        ]),
        startedAt: z.string().optional(),
        archivedAt: z.union([
            z.string(),
            z.null()
        ]),
        parentTournament: z.union([
            z.object({
                id: z.number(),
                parentTournamentId: z.union([
                    z.number(),
                    z.null()
                ]),
                type: z.enum([
                    'table',
                    'group',
                    'cup'
                ]),
                title: z.string(),
                about: z.union([
                    z.string(),
                    z.null()
                ]).optional(),
                withExtraPointsOnGameDraw: z.boolean(),
                with10mPenalty: z.boolean(),
                photos: z.union([
                    z.array(z.object({
                        id: z.number(),
                        tournamentId: z.union([
                            z.number(),
                            z.null()
                        ]),
                        url: z.string(),
                        storageKey: z.string(),
                        createdAt: z.string()
                    })),
                    z.null()
                ]).optional(),
                publishedAt: z.union([
                    z.string(),
                    z.null()
                ]),
                startedAt: z.string().optional(),
                archivedAt: z.union([
                    z.string(),
                    z.null()
                ])
            }),
            z.null()
        ]).optional(),
        childrenTournaments: z.union([
            z.array(z.object({
                id: z.number(),
                parentTournamentId: z.union([
                    z.number(),
                    z.null()
                ]),
                type: z.enum([
                    'table',
                    'group',
                    'cup'
                ]),
                title: z.string(),
                about: z.union([
                    z.string(),
                    z.null()
                ]).optional(),
                withExtraPointsOnGameDraw: z.boolean(),
                with10mPenalty: z.boolean(),
                photos: z.union([
                    z.array(z.object({
                        id: z.number(),
                        tournamentId: z.union([
                            z.number(),
                            z.null()
                        ]),
                        url: z.string(),
                        storageKey: z.string(),
                        createdAt: z.string()
                    })),
                    z.null()
                ]).optional(),
                publishedAt: z.union([
                    z.string(),
                    z.null()
                ]),
                startedAt: z.string().optional(),
                archivedAt: z.union([
                    z.string(),
                    z.null()
                ])
            })),
            z.null()
        ]).optional(),
        tournamentAwards: z.union([
            z.object({
                bestPlayerId: z.union([
                    z.number(),
                    z.null()
                ]).optional(),
                bestGoalkeeperId: z.union([
                    z.number(),
                    z.null()
                ]).optional(),
                topScorerId: z.union([
                    z.number(),
                    z.null()
                ]).optional(),
                bestAssistantId: z.union([
                    z.number(),
                    z.null()
                ]).optional(),
                firstTeamId: z.union([
                    z.number(),
                    z.null()
                ]).optional(),
                secondTeamId: z.union([
                    z.number(),
                    z.null()
                ]).optional(),
                thirdTeamId: z.union([
                    z.number(),
                    z.null()
                ]).optional(),
                firstTeam: z.union([
                    z.object({
                        id: z.number(),
                        teamId: z.number(),
                        tournamentId: z.number(),
                        groupId: z.union([
                            z.number(),
                            z.null()
                        ]).optional(),
                        group: z.union([
                            z.object({
                                id: z.number(),
                                name: z.string()
                            }),
                            z.null()
                        ]).optional(),
                        photoUrl: z.union([
                            z.string(),
                            z.null()
                        ]),
                        team: z.object({
                            id: z.number(),
                            name: z.string(),
                            logoUrl: z.union([
                                z.string(),
                                z.null()
                            ]),
                            foundedYear: z.union([
                                z.number(),
                                z.null()
                            ])
                        }),
                        order: z.number(),
                        extraPoints: z.number()
                    }),
                    z.null()
                ]).optional(),
                secondTeam: z.union([
                    z.object({
                        id: z.number(),
                        teamId: z.number(),
                        tournamentId: z.number(),
                        groupId: z.union([
                            z.number(),
                            z.null()
                        ]).optional(),
                        group: z.union([
                            z.object({
                                id: z.number(),
                                name: z.string()
                            }),
                            z.null()
                        ]).optional(),
                        photoUrl: z.union([
                            z.string(),
                            z.null()
                        ]),
                        team: z.object({
                            id: z.number(),
                            name: z.string(),
                            logoUrl: z.union([
                                z.string(),
                                z.null()
                            ]),
                            foundedYear: z.union([
                                z.number(),
                                z.null()
                            ])
                        }),
                        order: z.number(),
                        extraPoints: z.number()
                    }),
                    z.null()
                ]).optional(),
                thirdTeam: z.union([
                    z.object({
                        id: z.number(),
                        teamId: z.number(),
                        tournamentId: z.number(),
                        groupId: z.union([
                            z.number(),
                            z.null()
                        ]).optional(),
                        group: z.union([
                            z.object({
                                id: z.number(),
                                name: z.string()
                            }),
                            z.null()
                        ]).optional(),
                        photoUrl: z.union([
                            z.string(),
                            z.null()
                        ]),
                        team: z.object({
                            id: z.number(),
                            name: z.string(),
                            logoUrl: z.union([
                                z.string(),
                                z.null()
                            ]),
                            foundedYear: z.union([
                                z.number(),
                                z.null()
                            ])
                        }),
                        order: z.number(),
                        extraPoints: z.number()
                    }),
                    z.null()
                ]).optional(),
                bestPlayer: z.union([
                    z.object({
                        id: z.number(),
                        tournamentId: z.number(),
                        teamId: z.number(),
                        playerId: z.number(),
                        positionId: z.number(),
                        tournamentTeamId: z.number(),
                        player: z.object({
                            id: z.number(),
                            firstName: z.string(),
                            lastName: z.string(),
                            middleName: z.union([
                                z.string(),
                                z.null()
                            ]).optional(),
                            dateOfBirth: z.string(),
                            avatarUrl: z.union([
                                z.string(),
                                z.null()
                            ])
                        }),
                        number: z.number(),
                        status: z.enum([
                            'active',
                            'inactive',
                            'transferred-in',
                            'transferred-out'
                        ]),
                        startParticipantDate: z.string(),
                        endParticipantDate: z.union([
                            z.string(),
                            z.null()
                        ])
                    }),
                    z.null()
                ]).optional(),
                bestGoalkeeper: z.union([
                    z.object({
                        id: z.number(),
                        tournamentId: z.number(),
                        teamId: z.number(),
                        playerId: z.number(),
                        positionId: z.number(),
                        tournamentTeamId: z.number(),
                        player: z.object({
                            id: z.number(),
                            firstName: z.string(),
                            lastName: z.string(),
                            middleName: z.union([
                                z.string(),
                                z.null()
                            ]).optional(),
                            dateOfBirth: z.string(),
                            avatarUrl: z.union([
                                z.string(),
                                z.null()
                            ])
                        }),
                        number: z.number(),
                        status: z.enum([
                            'active',
                            'inactive',
                            'transferred-in',
                            'transferred-out'
                        ]),
                        startParticipantDate: z.string(),
                        endParticipantDate: z.union([
                            z.string(),
                            z.null()
                        ])
                    }),
                    z.null()
                ]).optional(),
                topScorer: z.union([
                    z.object({
                        id: z.number(),
                        tournamentId: z.number(),
                        teamId: z.number(),
                        playerId: z.number(),
                        positionId: z.number(),
                        tournamentTeamId: z.number(),
                        player: z.object({
                            id: z.number(),
                            firstName: z.string(),
                            lastName: z.string(),
                            middleName: z.union([
                                z.string(),
                                z.null()
                            ]).optional(),
                            dateOfBirth: z.string(),
                            avatarUrl: z.union([
                                z.string(),
                                z.null()
                            ])
                        }),
                        number: z.number(),
                        status: z.enum([
                            'active',
                            'inactive',
                            'transferred-in',
                            'transferred-out'
                        ]),
                        startParticipantDate: z.string(),
                        endParticipantDate: z.union([
                            z.string(),
                            z.null()
                        ])
                    }),
                    z.null()
                ]).optional(),
                bestAssistant: z.union([
                    z.object({
                        id: z.number(),
                        tournamentId: z.number(),
                        teamId: z.number(),
                        playerId: z.number(),
                        positionId: z.number(),
                        tournamentTeamId: z.number(),
                        player: z.object({
                            id: z.number(),
                            firstName: z.string(),
                            lastName: z.string(),
                            middleName: z.union([
                                z.string(),
                                z.null()
                            ]).optional(),
                            dateOfBirth: z.string(),
                            avatarUrl: z.union([
                                z.string(),
                                z.null()
                            ])
                        }),
                        number: z.number(),
                        status: z.enum([
                            'active',
                            'inactive',
                            'transferred-in',
                            'transferred-out'
                        ]),
                        startParticipantDate: z.string(),
                        endParticipantDate: z.union([
                            z.string(),
                            z.null()
                        ])
                    }),
                    z.null()
                ]).optional()
            }),
            z.null()
        ]).optional()
    })
});

export const zTournamentTeamsResultDto = z.object({
    success: z.boolean(),
    data: z.array(z.object({
        id: z.number(),
        teamId: z.number(),
        tournamentId: z.number(),
        groupId: z.union([
            z.number(),
            z.null()
        ]).optional(),
        group: z.union([
            z.object({
                id: z.number(),
                name: z.string()
            }),
            z.null()
        ]).optional(),
        photoUrl: z.union([
            z.string(),
            z.null()
        ]),
        team: z.object({
            id: z.number(),
            name: z.string(),
            logoUrl: z.union([
                z.string(),
                z.null()
            ]),
            foundedYear: z.union([
                z.number(),
                z.null()
            ])
        }),
        order: z.number(),
        extraPoints: z.number()
    }))
});

export const zTournamentParticipantsResultDto = z.object({
    success: z.boolean(),
    data: z.array(z.object({
        id: z.number(),
        tournamentId: z.number(),
        teamId: z.number(),
        playerId: z.number(),
        positionId: z.number(),
        tournamentTeamId: z.number(),
        player: z.object({
            id: z.number(),
            firstName: z.string(),
            lastName: z.string(),
            middleName: z.union([
                z.string(),
                z.null()
            ]).optional(),
            dateOfBirth: z.string(),
            avatarUrl: z.union([
                z.string(),
                z.null()
            ])
        }),
        number: z.number(),
        status: z.enum([
            'active',
            'inactive',
            'transferred-in',
            'transferred-out'
        ]),
        startParticipantDate: z.string(),
        endParticipantDate: z.union([
            z.string(),
            z.null()
        ])
    }))
});

export const zTournamentStandingsResultDto = z.object({
    success: z.boolean(),
    data: z.object({
        id: z.number(),
        parentTournamentId: z.union([
            z.number(),
            z.null()
        ]),
        type: z.enum([
            'table',
            'group',
            'cup'
        ]),
        title: z.string(),
        about: z.union([
            z.string(),
            z.null()
        ]).optional(),
        withExtraPointsOnGameDraw: z.boolean(),
        with10mPenalty: z.boolean(),
        photos: z.union([
            z.array(z.object({
                id: z.number(),
                tournamentId: z.union([
                    z.number(),
                    z.null()
                ]),
                url: z.string(),
                storageKey: z.string(),
                createdAt: z.string()
            })),
            z.null()
        ]).optional(),
        publishedAt: z.union([
            z.string(),
            z.null()
        ]),
        startedAt: z.string().optional(),
        archivedAt: z.union([
            z.string(),
            z.null()
        ]),
        parentTournament: z.union([
            z.object({
                id: z.number(),
                parentTournamentId: z.union([
                    z.number(),
                    z.null()
                ]),
                type: z.enum([
                    'table',
                    'group',
                    'cup'
                ]),
                title: z.string(),
                about: z.union([
                    z.string(),
                    z.null()
                ]).optional(),
                withExtraPointsOnGameDraw: z.boolean(),
                with10mPenalty: z.boolean(),
                photos: z.union([
                    z.array(z.object({
                        id: z.number(),
                        tournamentId: z.union([
                            z.number(),
                            z.null()
                        ]),
                        url: z.string(),
                        storageKey: z.string(),
                        createdAt: z.string()
                    })),
                    z.null()
                ]).optional(),
                publishedAt: z.union([
                    z.string(),
                    z.null()
                ]),
                startedAt: z.string().optional(),
                archivedAt: z.union([
                    z.string(),
                    z.null()
                ])
            }),
            z.null()
        ]).optional(),
        childrenTournaments: z.union([
            z.array(z.object({
                id: z.number(),
                parentTournamentId: z.union([
                    z.number(),
                    z.null()
                ]),
                type: z.enum([
                    'table',
                    'group',
                    'cup'
                ]),
                title: z.string(),
                about: z.union([
                    z.string(),
                    z.null()
                ]).optional(),
                withExtraPointsOnGameDraw: z.boolean(),
                with10mPenalty: z.boolean(),
                photos: z.union([
                    z.array(z.object({
                        id: z.number(),
                        tournamentId: z.union([
                            z.number(),
                            z.null()
                        ]),
                        url: z.string(),
                        storageKey: z.string(),
                        createdAt: z.string()
                    })),
                    z.null()
                ]).optional(),
                publishedAt: z.union([
                    z.string(),
                    z.null()
                ]),
                startedAt: z.string().optional(),
                archivedAt: z.union([
                    z.string(),
                    z.null()
                ])
            })),
            z.null()
        ]).optional(),
        teams: z.array(z.object({
            id: z.number(),
            teamId: z.number(),
            tournamentId: z.number(),
            groupId: z.union([
                z.number(),
                z.null()
            ]).optional(),
            group: z.union([
                z.object({
                    id: z.number(),
                    name: z.string()
                }),
                z.null()
            ]).optional(),
            photoUrl: z.union([
                z.string(),
                z.null()
            ]),
            team: z.object({
                id: z.number(),
                name: z.string(),
                logoUrl: z.union([
                    z.string(),
                    z.null()
                ]),
                foundedYear: z.union([
                    z.number(),
                    z.null()
                ])
            }),
            order: z.number(),
            extraPoints: z.number()
        })),
        games: z.array(z.object({
            id: z.number(),
            tournamentId: z.number(),
            tourId: z.number(),
            teamOneId: z.union([
                z.number(),
                z.null()
            ]),
            teamTwoId: z.union([
                z.number(),
                z.null()
            ]),
            teamOnePlaceholder: z.string(),
            teamTwoPlaceholder: z.string(),
            teamOneGoals: z.number(),
            teamOnePenaltyGoals: z.number(),
            teamTwoGoals: z.number(),
            teamTwoPenaltyGoals: z.number(),
            isPostponed: z.boolean(),
            isProblematicGame: z.boolean(),
            date: z.union([
                z.string(),
                z.null()
            ]),
            postponementDate: z.union([
                z.string(),
                z.null()
            ]),
            notes: z.string(),
            status: z.enum([
                'default',
                'under-review',
                'finished',
                'canceled'
            ]),
            teamOne: z.union([
                z.object({
                    id: z.number(),
                    name: z.string(),
                    logoUrl: z.union([
                        z.string(),
                        z.null()
                    ]),
                    foundedYear: z.union([
                        z.number(),
                        z.null()
                    ])
                }),
                z.null()
            ]).optional(),
            teamTwo: z.union([
                z.object({
                    id: z.number(),
                    name: z.string(),
                    logoUrl: z.union([
                        z.string(),
                        z.null()
                    ]),
                    foundedYear: z.union([
                        z.number(),
                        z.null()
                    ])
                }),
                z.null()
            ]).optional()
        }))
    })
});

export const zTournamentMediaResultDto = z.object({
    success: z.boolean(),
    data: z.array(z.object({
        id: z.number(),
        tournamentId: z.union([
            z.number(),
            z.null()
        ]),
        url: z.string(),
        storageKey: z.string(),
        createdAt: z.string()
    }))
});

export const zSyncWithParentTournamentDto = z.object({
    parentTournamentId: z.number()
});

export const zUpdateTournamentDto = z.object({
    parentTournamentId: z.number().optional(),
    title: z.string().min(1).optional(),
    about: z.string().optional(),
    startedAt: z.string().optional(),
    type: z.enum([
        'table',
        'group',
        'cup'
    ]).optional(),
    withExtraPointsOnGameDraw: z.boolean().optional(),
    with10mPenalty: z.boolean().optional()
});

export const zUpdateTournamentResultsDto = z.object({
    bestPlayerId: z.union([
        z.number(),
        z.null()
    ]).optional(),
    bestGoalkeeperId: z.union([
        z.number(),
        z.null()
    ]).optional(),
    topScorerId: z.union([
        z.number(),
        z.null()
    ]).optional(),
    bestAssistantId: z.union([
        z.number(),
        z.null()
    ]).optional(),
    firstTeamId: z.union([
        z.number(),
        z.null()
    ]).optional(),
    secondTeamId: z.union([
        z.number(),
        z.null()
    ]).optional(),
    thirdTeamId: z.union([
        z.number(),
        z.null()
    ]).optional()
});

export const zCreateTournamentDto = z.object({
    parentTournamentId: z.number().optional(),
    title: z.string().min(1),
    about: z.string(),
    startedAt: z.string(),
    type: z.enum([
        'table',
        'group',
        'cup'
    ]),
    withExtraPointsOnGameDraw: z.boolean(),
    with10mPenalty: z.boolean()
});

export const zUpdateTournamentPhotosSchemaDto = z.object({
    photos: z.array(z.object({
        tournamentId: z.union([
            z.number(),
            z.null()
        ]),
        url: z.string(),
        storageKey: z.string(),
        id: z.number().optional()
    }))
});

export const zChangeTournamentTeamsOrderSchemaDto = z.object({
    teams: z.array(z.number())
});

export const zImportTeamMembershipDto = z.object({
    tournamentId: z.number(),
    tournamentTeamId: z.number(),
    teamId: z.number()
});

export const zAddTeamMembershipDto = z.object({
    tournamentId: z.number(),
    teamId: z.number(),
    tournamentTeamId: z.number(),
    playerId: z.number(),
    positionId: z.number(),
    number: z.number(),
    status: z.enum([
        'active',
        'inactive',
        'transferred-in',
        'transferred-out'
    ]),
    startParticipantDate: z.string(),
    endParticipantDate: z.union([
        z.string(),
        z.null()
    ]).optional()
});

export const zGetTeamMembershipResult = z.object({
    success: z.boolean(),
    data: z.array(z.object({
        id: z.number(),
        tournamentId: z.number(),
        teamId: z.number(),
        playerId: z.number(),
        positionId: z.number(),
        tournamentTeamId: z.number(),
        player: z.object({
            id: z.number(),
            firstName: z.string(),
            lastName: z.string(),
            middleName: z.union([
                z.string(),
                z.null()
            ]).optional(),
            dateOfBirth: z.string(),
            avatarUrl: z.union([
                z.string(),
                z.null()
            ])
        }),
        team: z.object({
            id: z.number(),
            name: z.string(),
            logoUrl: z.union([
                z.string(),
                z.null()
            ]),
            foundedYear: z.union([
                z.number(),
                z.null()
            ])
        }),
        position: z.object({
            id: z.number(),
            title: z.string()
        }),
        number: z.number(),
        status: z.enum([
            'active',
            'inactive',
            'transferred-in',
            'transferred-out'
        ]),
        startParticipantDate: z.string(),
        endParticipantDate: z.union([
            z.string(),
            z.null()
        ])
    }))
});

export const zCreateTourTypeDto = z.object({
    name: z.string()
});

export const zTourTypesPaginationResult = z.object({
    success: z.boolean(),
    data: z.object({
        items: z.array(z.object({
            id: z.number(),
            name: z.string()
        })),
        page: z.object({
            total: z.number(),
            skip: z.number(),
            limit: z.number()
        })
    })
});

export const zTourTypeResultDto = z.object({
    success: z.boolean(),
    data: z.object({
        id: z.number(),
        name: z.string()
    })
});

export const zUpdateTourTypeDto = z.object({
    name: z.string().optional()
});

export const zRefereesPaginationResult = z.object({
    success: z.boolean(),
    data: z.object({
        items: z.array(z.object({
            id: z.number(),
            firstName: z.string(),
            lastName: z.string(),
            middleName: z.union([
                z.string(),
                z.null()
            ]).optional(),
            dateOfBirth: z.string(),
            avatarUrl: z.union([
                z.string(),
                z.null()
            ])
        })),
        page: z.object({
            total: z.number(),
            skip: z.number(),
            limit: z.number()
        })
    })
});

export const zWebsiteRefereesPaginationResult = z.object({
    success: z.boolean(),
    data: z.object({
        items: z.array(z.object({
            id: z.number(),
            firstName: z.string(),
            lastName: z.string(),
            middleName: z.union([
                z.string(),
                z.null()
            ]).optional(),
            dateOfBirth: z.string(),
            avatarUrl: z.union([
                z.string(),
                z.null()
            ]),
            gamesAmount: z.number().optional()
        })),
        page: z.object({
            total: z.number(),
            skip: z.number(),
            limit: z.number()
        })
    })
});

export const zRefereeResultDto = z.object({
    success: z.boolean(),
    data: z.object({
        id: z.number(),
        firstName: z.string(),
        lastName: z.string(),
        middleName: z.union([
            z.string(),
            z.null()
        ]).optional(),
        dateOfBirth: z.string(),
        avatarUrl: z.union([
            z.string(),
            z.null()
        ])
    })
});

export const zPlayersPaginationResult = z.object({
    success: z.boolean(),
    data: z.object({
        items: z.array(z.object({
            id: z.number(),
            firstName: z.string(),
            lastName: z.string(),
            middleName: z.union([
                z.string(),
                z.null()
            ]).optional(),
            dateOfBirth: z.string(),
            avatarUrl: z.union([
                z.string(),
                z.null()
            ])
        })),
        page: z.object({
            total: z.number(),
            skip: z.number(),
            limit: z.number()
        })
    })
});

export const zWebsitePlayersPaginationResult = z.object({
    success: z.boolean(),
    data: z.object({
        items: z.array(z.object({
            id: z.number(),
            firstName: z.string(),
            lastName: z.string(),
            middleName: z.union([
                z.string(),
                z.null()
            ]).optional(),
            dateOfBirth: z.string(),
            avatarUrl: z.union([
                z.string(),
                z.null()
            ])
        })),
        page: z.object({
            total: z.number(),
            skip: z.number(),
            limit: z.number()
        })
    })
});

export const zPlayerWithMembershipResultDto = z.object({
    success: z.boolean(),
    data: z.object({
        id: z.number(),
        firstName: z.string(),
        lastName: z.string(),
        middleName: z.union([
            z.string(),
            z.null()
        ]).optional(),
        dateOfBirth: z.string(),
        avatarUrl: z.union([
            z.string(),
            z.null()
        ]),
        teamMemberships: z.union([
            z.array(z.object({
                id: z.number(),
                tournamentId: z.number(),
                teamId: z.number(),
                playerId: z.number(),
                positionId: z.number(),
                tournamentTeamId: z.number(),
                team: z.object({
                    id: z.number(),
                    name: z.string(),
                    logoUrl: z.union([
                        z.string(),
                        z.null()
                    ]),
                    foundedYear: z.union([
                        z.number(),
                        z.null()
                    ])
                }),
                position: z.object({
                    id: z.number(),
                    title: z.string()
                }),
                number: z.number(),
                status: z.enum([
                    'active',
                    'inactive',
                    'transferred-in',
                    'transferred-out'
                ]),
                startParticipantDate: z.string(),
                endParticipantDate: z.union([
                    z.string(),
                    z.null()
                ])
            })),
            z.null()
        ]).optional(),
        statsByTournament: z.array(z.object({
            number: z.number(),
            team: z.string(),
            tournament: z.string(),
            teamId: z.number(),
            tournamentId: z.number(),
            tournamentStartedAt: z.string(),
            position: z.string(),
            games: z.number(),
            goals: z.number(),
            passes: z.number(),
            yellowCards: z.number(),
            redCards: z.number()
        })),
        stats: z.object({
            goals: z.number(),
            games: z.number(),
            passes: z.number(),
            yellowCards: z.number(),
            redCards: z.number()
        }).optional(),
        awards: z.union([
            z.object({
                personal: z.array(z.object({
                    type: z.enum([
                        'bestPlayer',
                        'bestGoalkeeper',
                        'topScorer',
                        'bestAssistant'
                    ]),
                    tournament: z.union([
                        z.object({
                            id: z.number(),
                            parentTournamentId: z.union([
                                z.number(),
                                z.null()
                            ]),
                            type: z.enum([
                                'table',
                                'group',
                                'cup'
                            ]),
                            title: z.string(),
                            about: z.union([
                                z.string(),
                                z.null()
                            ]).optional(),
                            withExtraPointsOnGameDraw: z.boolean(),
                            with10mPenalty: z.boolean(),
                            photos: z.union([
                                z.array(z.object({
                                    id: z.number(),
                                    tournamentId: z.union([
                                        z.number(),
                                        z.null()
                                    ]),
                                    url: z.string(),
                                    storageKey: z.string(),
                                    createdAt: z.string()
                                })),
                                z.null()
                            ]).optional(),
                            publishedAt: z.union([
                                z.string(),
                                z.null()
                            ]),
                            startedAt: z.string().optional(),
                            archivedAt: z.union([
                                z.string(),
                                z.null()
                            ]),
                            parentTournament: z.union([
                                z.object({
                                    id: z.number(),
                                    parentTournamentId: z.union([
                                        z.number(),
                                        z.null()
                                    ]),
                                    type: z.enum([
                                        'table',
                                        'group',
                                        'cup'
                                    ]),
                                    title: z.string(),
                                    about: z.union([
                                        z.string(),
                                        z.null()
                                    ]).optional(),
                                    withExtraPointsOnGameDraw: z.boolean(),
                                    with10mPenalty: z.boolean(),
                                    photos: z.union([
                                        z.array(z.object({
                                            id: z.number(),
                                            tournamentId: z.union([
                                                z.number(),
                                                z.null()
                                            ]),
                                            url: z.string(),
                                            storageKey: z.string(),
                                            createdAt: z.string()
                                        })),
                                        z.null()
                                    ]).optional(),
                                    publishedAt: z.union([
                                        z.string(),
                                        z.null()
                                    ]),
                                    startedAt: z.string().optional(),
                                    archivedAt: z.union([
                                        z.string(),
                                        z.null()
                                    ])
                                }),
                                z.null()
                            ]).optional(),
                            childrenTournaments: z.union([
                                z.array(z.object({
                                    id: z.number(),
                                    parentTournamentId: z.union([
                                        z.number(),
                                        z.null()
                                    ]),
                                    type: z.enum([
                                        'table',
                                        'group',
                                        'cup'
                                    ]),
                                    title: z.string(),
                                    about: z.union([
                                        z.string(),
                                        z.null()
                                    ]).optional(),
                                    withExtraPointsOnGameDraw: z.boolean(),
                                    with10mPenalty: z.boolean(),
                                    photos: z.union([
                                        z.array(z.object({
                                            id: z.number(),
                                            tournamentId: z.union([
                                                z.number(),
                                                z.null()
                                            ]),
                                            url: z.string(),
                                            storageKey: z.string(),
                                            createdAt: z.string()
                                        })),
                                        z.null()
                                    ]).optional(),
                                    publishedAt: z.union([
                                        z.string(),
                                        z.null()
                                    ]),
                                    startedAt: z.string().optional(),
                                    archivedAt: z.union([
                                        z.string(),
                                        z.null()
                                    ])
                                })),
                                z.null()
                            ]).optional()
                        }),
                        z.null()
                    ]).optional()
                })),
                team: z.array(z.object({
                    place: z.number(),
                    tournament: z.union([
                        z.object({
                            id: z.number(),
                            parentTournamentId: z.union([
                                z.number(),
                                z.null()
                            ]),
                            type: z.enum([
                                'table',
                                'group',
                                'cup'
                            ]),
                            title: z.string(),
                            about: z.union([
                                z.string(),
                                z.null()
                            ]).optional(),
                            withExtraPointsOnGameDraw: z.boolean(),
                            with10mPenalty: z.boolean(),
                            photos: z.union([
                                z.array(z.object({
                                    id: z.number(),
                                    tournamentId: z.union([
                                        z.number(),
                                        z.null()
                                    ]),
                                    url: z.string(),
                                    storageKey: z.string(),
                                    createdAt: z.string()
                                })),
                                z.null()
                            ]).optional(),
                            publishedAt: z.union([
                                z.string(),
                                z.null()
                            ]),
                            startedAt: z.string().optional(),
                            archivedAt: z.union([
                                z.string(),
                                z.null()
                            ]),
                            parentTournament: z.union([
                                z.object({
                                    id: z.number(),
                                    parentTournamentId: z.union([
                                        z.number(),
                                        z.null()
                                    ]),
                                    type: z.enum([
                                        'table',
                                        'group',
                                        'cup'
                                    ]),
                                    title: z.string(),
                                    about: z.union([
                                        z.string(),
                                        z.null()
                                    ]).optional(),
                                    withExtraPointsOnGameDraw: z.boolean(),
                                    with10mPenalty: z.boolean(),
                                    photos: z.union([
                                        z.array(z.object({
                                            id: z.number(),
                                            tournamentId: z.union([
                                                z.number(),
                                                z.null()
                                            ]),
                                            url: z.string(),
                                            storageKey: z.string(),
                                            createdAt: z.string()
                                        })),
                                        z.null()
                                    ]).optional(),
                                    publishedAt: z.union([
                                        z.string(),
                                        z.null()
                                    ]),
                                    startedAt: z.string().optional(),
                                    archivedAt: z.union([
                                        z.string(),
                                        z.null()
                                    ])
                                }),
                                z.null()
                            ]).optional(),
                            childrenTournaments: z.union([
                                z.array(z.object({
                                    id: z.number(),
                                    parentTournamentId: z.union([
                                        z.number(),
                                        z.null()
                                    ]),
                                    type: z.enum([
                                        'table',
                                        'group',
                                        'cup'
                                    ]),
                                    title: z.string(),
                                    about: z.union([
                                        z.string(),
                                        z.null()
                                    ]).optional(),
                                    withExtraPointsOnGameDraw: z.boolean(),
                                    with10mPenalty: z.boolean(),
                                    photos: z.union([
                                        z.array(z.object({
                                            id: z.number(),
                                            tournamentId: z.union([
                                                z.number(),
                                                z.null()
                                            ]),
                                            url: z.string(),
                                            storageKey: z.string(),
                                            createdAt: z.string()
                                        })),
                                        z.null()
                                    ]).optional(),
                                    publishedAt: z.union([
                                        z.string(),
                                        z.null()
                                    ]),
                                    startedAt: z.string().optional(),
                                    archivedAt: z.union([
                                        z.string(),
                                        z.null()
                                    ])
                                })),
                                z.null()
                            ]).optional()
                        }),
                        z.null()
                    ]).optional(),
                    team: z.union([
                        z.object({
                            id: z.number(),
                            name: z.string(),
                            logoUrl: z.union([
                                z.string(),
                                z.null()
                            ]),
                            foundedYear: z.union([
                                z.number(),
                                z.null()
                            ])
                        }),
                        z.null()
                    ]).optional()
                }))
            }),
            z.null()
        ]).optional()
    })
});

export const zPlayerResultDto = z.object({
    success: z.boolean(),
    data: z.object({
        id: z.number(),
        firstName: z.string(),
        lastName: z.string(),
        middleName: z.union([
            z.string(),
            z.null()
        ]).optional(),
        dateOfBirth: z.string(),
        avatarUrl: z.union([
            z.string(),
            z.null()
        ])
    })
});

export const zCreateGroupDto = z.object({
    name: z.string()
});

export const zPaginationResult = z.object({
    success: z.boolean(),
    data: z.object({
        items: z.array(z.object({
            id: z.number(),
            name: z.string()
        })),
        page: z.object({
            total: z.number(),
            skip: z.number(),
            limit: z.number()
        })
    })
});

export const zGroupResultDto = z.object({
    success: z.boolean(),
    data: z.object({
        id: z.number(),
        name: z.string()
    })
});

export const zGetUserResultResult = z.object({
    success: z.boolean(),
    data: z.object({
        id: z.number(),
        role: z.enum([
            'DEVELOPER',
            'EDITOR',
            'ADMIN'
        ]),
        scope: z.array(z.string()).optional().default([]),
        email: z.string().email(),
        firstName: z.string(),
        lastName: z.string(),
        avatarUrl: z.union([
            z.string(),
            z.null()
        ]).optional()
    })
});

export const zUsersPaginationResult = z.object({
    success: z.boolean(),
    data: z.object({
        items: z.array(z.object({
            id: z.number(),
            role: z.enum([
                'DEVELOPER',
                'EDITOR',
                'ADMIN'
            ]),
            scope: z.array(z.string()).optional().default([]),
            email: z.string().email(),
            firstName: z.string(),
            lastName: z.string(),
            avatarUrl: z.union([
                z.string(),
                z.null()
            ]).optional()
        })),
        page: z.object({
            total: z.number(),
            skip: z.number(),
            limit: z.number()
        })
    })
});

export const zLoginDto = z.object({
    email: z.string().email(),
    password: z.string(),
    twoFactorCode: z.union([
        z.string().regex(/^\d+$/),
        z.null()
    ]).optional()
});

export const zLoginResponseDto = z.object({
    success: z.boolean(),
    data: z.union([
        z.object({
            type: z.enum(['success']),
            id: z.number()
        }),
        z.object({
            type: z.enum(['2fa_token_required'])
        })
    ])
});

export const zTeamsPaginationResult = z.object({
    success: z.boolean(),
    data: z.object({
        items: z.array(z.object({
            id: z.number(),
            name: z.string(),
            logoUrl: z.union([
                z.string(),
                z.null()
            ]),
            foundedYear: z.union([
                z.number(),
                z.null()
            ])
        })),
        page: z.object({
            total: z.number(),
            skip: z.number(),
            limit: z.number()
        })
    })
});

export const zWebsiteTeamResultDto = z.object({
    success: z.boolean(),
    data: z.object({
        id: z.number(),
        name: z.string(),
        logoUrl: z.union([
            z.string(),
            z.null()
        ]),
        foundedYear: z.union([
            z.number(),
            z.null()
        ]),
        tournamentTeams: z.array(z.object({
            id: z.number(),
            teamId: z.number(),
            tournamentId: z.number(),
            groupId: z.union([
                z.number(),
                z.null()
            ]).optional(),
            group: z.union([
                z.object({
                    id: z.number(),
                    name: z.string()
                }),
                z.null()
            ]).optional(),
            photoUrl: z.union([
                z.string(),
                z.null()
            ]),
            order: z.number(),
            extraPoints: z.number(),
            tournament: z.object({
                id: z.number(),
                title: z.string(),
                startedAt: z.string().optional(),
                tournamentAwards: z.union([
                    z.object({
                        firstTeamId: z.union([
                            z.number(),
                            z.null()
                        ]).optional(),
                        secondTeamId: z.union([
                            z.number(),
                            z.null()
                        ]).optional(),
                        thirdTeamId: z.union([
                            z.number(),
                            z.null()
                        ]).optional()
                    }),
                    z.null()
                ])
            })
        })).optional()
    })
});

export const zTeamStatsByTournamentDto = z.object({
    success: z.boolean(),
    data: z.object({
        photoUrl: z.union([
            z.string(),
            z.null()
        ]),
        members: z.array(z.object({
            id: z.number(),
            tournamentId: z.number(),
            teamId: z.number(),
            playerId: z.number(),
            positionId: z.number(),
            tournamentTeamId: z.number(),
            player: z.object({
                id: z.number(),
                firstName: z.string(),
                lastName: z.string(),
                middleName: z.union([
                    z.string(),
                    z.null()
                ]).optional(),
                dateOfBirth: z.string(),
                avatarUrl: z.union([
                    z.string(),
                    z.null()
                ])
            }),
            position: z.object({
                id: z.number(),
                title: z.string()
            }),
            number: z.number(),
            status: z.enum([
                'active',
                'inactive',
                'transferred-in',
                'transferred-out'
            ]),
            startParticipantDate: z.string(),
            endParticipantDate: z.union([
                z.string(),
                z.null()
            ]),
            played: z.number(),
            goals: z.number(),
            passes: z.number(),
            yellow: z.number(),
            red: z.number()
        })),
        games: z.array(z.object({
            id: z.number(),
            teamOneGoals: z.number(),
            teamTwoGoals: z.number(),
            teamOnePenaltyGoals: z.number(),
            teamTwoPenaltyGoals: z.number(),
            teamOne: z.union([
                z.object({
                    id: z.number(),
                    name: z.string(),
                    logoUrl: z.union([
                        z.string(),
                        z.null()
                    ]),
                    foundedYear: z.union([
                        z.number(),
                        z.null()
                    ])
                }),
                z.null()
            ]).optional(),
            teamTwo: z.union([
                z.object({
                    id: z.number(),
                    name: z.string(),
                    logoUrl: z.union([
                        z.string(),
                        z.null()
                    ]),
                    foundedYear: z.union([
                        z.number(),
                        z.null()
                    ])
                }),
                z.null()
            ]).optional(),
            status: z.enum([
                'default',
                'under-review',
                'finished',
                'canceled'
            ]),
            date: z.union([
                z.string(),
                z.null()
            ]),
            tourId: z.number(),
            tour: z.object({
                id: z.number(),
                name: z.string()
            }),
            isPostponed: z.boolean(),
            postponementDate: z.union([
                z.string(),
                z.null()
            ])
        }))
    })
});

export const zTeamResultDto = z.object({
    success: z.boolean(),
    data: z.object({
        id: z.number(),
        name: z.string(),
        logoUrl: z.union([
            z.string(),
            z.null()
        ]),
        foundedYear: z.union([
            z.number(),
            z.null()
        ])
    })
});

export const zCreateGameDto = z.object({
    tourId: z.number().gt(0),
    tournamentId: z.number().gt(0),
    teamOneId: z.number().gt(0).optional(),
    teamOnePlaceholder: z.string().optional(),
    teamTwoId: z.number().gt(0).optional(),
    teamTwoPlaceholder: z.string().optional(),
    teamOneGoals: z.number().optional().default(0),
    teamOnePenaltyGoals: z.number().optional().default(0),
    teamTwoGoals: z.number().optional().default(0),
    teamTwoPenaltyGoals: z.number().optional().default(0),
    isProblematicGame: z.boolean().optional().default(false),
    isPostponed: z.boolean().optional().default(false),
    date: z.union([
        z.string(),
        z.null()
    ]).optional(),
    postponementDate: z.union([
        z.string(),
        z.null()
    ]),
    notes: z.string().optional().default(''),
    status: z.enum([
        'default',
        'under-review',
        'finished',
        'canceled'
    ]),
    refereesIds: z.array(z.number()).optional(),
    participants: z.array(z.object({
        id: z.number().optional(),
        gameId: z.number(),
        teamMembershipId: z.number()
    })).optional(),
    referees: z.array(z.object({
        id: z.number().optional(),
        gameId: z.number(),
        refereeId: z.number()
    })).optional(),
    goals: z.array(z.object({
        id: z.number().optional(),
        gameId: z.number(),
        teamMembershipId: z.number(),
        minute: z.number(),
        isOwnGoal: z.boolean(),
        isFromPenalty: z.boolean(),
        isFrom10m: z.boolean()
    })).optional(),
    passes: z.array(z.object({
        id: z.number().optional(),
        gameId: z.number(),
        teamMembershipId: z.number(),
        minute: z.number()
    })).optional(),
    fouls: z.array(z.object({
        id: z.number().optional(),
        gameId: z.number(),
        teamMembershipId: z.number(),
        minute: z.number(),
        reason: z.string().max(80),
        card: z.enum(['yellow', 'red'])
    })).optional()
});

export const zGetGamesResultDto = z.object({
    success: z.boolean(),
    data: z.array(z.object({
        id: z.number(),
        tournamentId: z.number(),
        tourId: z.number(),
        teamOneId: z.union([
            z.number(),
            z.null()
        ]),
        teamTwoId: z.union([
            z.number(),
            z.null()
        ]),
        teamOnePlaceholder: z.string(),
        teamTwoPlaceholder: z.string(),
        teamOneGoals: z.number(),
        teamOnePenaltyGoals: z.number(),
        teamTwoGoals: z.number(),
        teamTwoPenaltyGoals: z.number(),
        isPostponed: z.boolean(),
        isProblematicGame: z.boolean(),
        date: z.union([
            z.string(),
            z.null()
        ]),
        postponementDate: z.union([
            z.string(),
            z.null()
        ]),
        notes: z.string(),
        status: z.enum([
            'default',
            'under-review',
            'finished',
            'canceled'
        ]),
        tour: z.object({
            id: z.number(),
            name: z.string()
        }),
        teamOne: z.union([
            z.object({
                id: z.number(),
                name: z.string(),
                logoUrl: z.union([
                    z.string(),
                    z.null()
                ]),
                foundedYear: z.union([
                    z.number(),
                    z.null()
                ])
            }),
            z.null()
        ]).optional(),
        teamTwo: z.union([
            z.object({
                id: z.number(),
                name: z.string(),
                logoUrl: z.union([
                    z.string(),
                    z.null()
                ]),
                foundedYear: z.union([
                    z.number(),
                    z.null()
                ])
            }),
            z.null()
        ]).optional()
    }))
});

export const zGetGameResultDto = z.object({
    success: z.boolean(),
    data: z.object({
        id: z.number(),
        tournamentId: z.number(),
        tourId: z.number(),
        teamOneId: z.union([
            z.number(),
            z.null()
        ]),
        teamTwoId: z.union([
            z.number(),
            z.null()
        ]),
        teamOnePlaceholder: z.string(),
        teamTwoPlaceholder: z.string(),
        teamOneGoals: z.number(),
        teamOnePenaltyGoals: z.number(),
        teamTwoGoals: z.number(),
        teamTwoPenaltyGoals: z.number(),
        isPostponed: z.boolean(),
        isProblematicGame: z.boolean(),
        date: z.union([
            z.string(),
            z.null()
        ]),
        postponementDate: z.union([
            z.string(),
            z.null()
        ]),
        notes: z.string(),
        status: z.enum([
            'default',
            'under-review',
            'finished',
            'canceled'
        ]),
        tour: z.object({
            id: z.number(),
            name: z.string()
        }),
        teamOne: z.union([
            z.object({
                id: z.number(),
                name: z.string(),
                logoUrl: z.union([
                    z.string(),
                    z.null()
                ]),
                foundedYear: z.union([
                    z.number(),
                    z.null()
                ])
            }),
            z.null()
        ]).optional(),
        teamTwo: z.union([
            z.object({
                id: z.number(),
                name: z.string(),
                logoUrl: z.union([
                    z.string(),
                    z.null()
                ]),
                foundedYear: z.union([
                    z.number(),
                    z.null()
                ])
            }),
            z.null()
        ]).optional(),
        tournament: z.object({
            id: z.number(),
            parentTournamentId: z.union([
                z.number(),
                z.null()
            ]),
            type: z.enum([
                'table',
                'group',
                'cup'
            ]),
            title: z.string(),
            about: z.union([
                z.string(),
                z.null()
            ]).optional(),
            withExtraPointsOnGameDraw: z.boolean(),
            with10mPenalty: z.boolean(),
            photos: z.union([
                z.array(z.object({
                    id: z.number(),
                    tournamentId: z.union([
                        z.number(),
                        z.null()
                    ]),
                    url: z.string(),
                    storageKey: z.string(),
                    createdAt: z.string()
                })),
                z.null()
            ]).optional(),
            publishedAt: z.union([
                z.string(),
                z.null()
            ]),
            startedAt: z.string().optional(),
            archivedAt: z.union([
                z.string(),
                z.null()
            ]),
            parentTournament: z.union([
                z.object({
                    id: z.number(),
                    parentTournamentId: z.union([
                        z.number(),
                        z.null()
                    ]),
                    type: z.enum([
                        'table',
                        'group',
                        'cup'
                    ]),
                    title: z.string(),
                    about: z.union([
                        z.string(),
                        z.null()
                    ]).optional(),
                    withExtraPointsOnGameDraw: z.boolean(),
                    with10mPenalty: z.boolean(),
                    photos: z.union([
                        z.array(z.object({
                            id: z.number(),
                            tournamentId: z.union([
                                z.number(),
                                z.null()
                            ]),
                            url: z.string(),
                            storageKey: z.string(),
                            createdAt: z.string()
                        })),
                        z.null()
                    ]).optional(),
                    publishedAt: z.union([
                        z.string(),
                        z.null()
                    ]),
                    startedAt: z.string().optional(),
                    archivedAt: z.union([
                        z.string(),
                        z.null()
                    ])
                }),
                z.null()
            ]).optional(),
            childrenTournaments: z.union([
                z.array(z.object({
                    id: z.number(),
                    parentTournamentId: z.union([
                        z.number(),
                        z.null()
                    ]),
                    type: z.enum([
                        'table',
                        'group',
                        'cup'
                    ]),
                    title: z.string(),
                    about: z.union([
                        z.string(),
                        z.null()
                    ]).optional(),
                    withExtraPointsOnGameDraw: z.boolean(),
                    with10mPenalty: z.boolean(),
                    photos: z.union([
                        z.array(z.object({
                            id: z.number(),
                            tournamentId: z.union([
                                z.number(),
                                z.null()
                            ]),
                            url: z.string(),
                            storageKey: z.string(),
                            createdAt: z.string()
                        })),
                        z.null()
                    ]).optional(),
                    publishedAt: z.union([
                        z.string(),
                        z.null()
                    ]),
                    startedAt: z.string().optional(),
                    archivedAt: z.union([
                        z.string(),
                        z.null()
                    ])
                })),
                z.null()
            ]).optional()
        }),
        referees: z.array(z.object({
            id: z.number(),
            gameId: z.number(),
            refereeId: z.number(),
            referee: z.object({
                id: z.number(),
                firstName: z.string(),
                lastName: z.string(),
                middleName: z.union([
                    z.string(),
                    z.null()
                ]).optional(),
                dateOfBirth: z.string(),
                avatarUrl: z.union([
                    z.string(),
                    z.null()
                ])
            })
        })).optional(),
        participants: z.array(z.object({
            id: z.number(),
            gameId: z.number(),
            teamMembershipId: z.number()
        })).optional(),
        fouls: z.array(z.object({
            id: z.number(),
            gameId: z.number(),
            teamMembershipId: z.number(),
            minute: z.number(),
            reason: z.string(),
            card: z.enum(['yellow', 'red']),
            teamMembership: z.object({
                id: z.number(),
                tournamentId: z.number(),
                teamId: z.number(),
                playerId: z.number(),
                positionId: z.number(),
                tournamentTeamId: z.number(),
                player: z.object({
                    id: z.number(),
                    firstName: z.string(),
                    lastName: z.string(),
                    middleName: z.union([
                        z.string(),
                        z.null()
                    ]).optional(),
                    dateOfBirth: z.string(),
                    avatarUrl: z.union([
                        z.string(),
                        z.null()
                    ])
                }),
                number: z.number(),
                status: z.enum([
                    'active',
                    'inactive',
                    'transferred-in',
                    'transferred-out'
                ]),
                startParticipantDate: z.string(),
                endParticipantDate: z.union([
                    z.string(),
                    z.null()
                ])
            })
        })).optional(),
        goals: z.array(z.object({
            id: z.number(),
            gameId: z.number(),
            teamMembershipId: z.number(),
            minute: z.number(),
            isOwnGoal: z.boolean(),
            isFromPenalty: z.boolean(),
            isFrom10m: z.boolean(),
            teamMembership: z.object({
                id: z.number(),
                tournamentId: z.number(),
                teamId: z.number(),
                playerId: z.number(),
                positionId: z.number(),
                tournamentTeamId: z.number(),
                player: z.object({
                    id: z.number(),
                    firstName: z.string(),
                    lastName: z.string(),
                    middleName: z.union([
                        z.string(),
                        z.null()
                    ]).optional(),
                    dateOfBirth: z.string(),
                    avatarUrl: z.union([
                        z.string(),
                        z.null()
                    ])
                }),
                number: z.number(),
                status: z.enum([
                    'active',
                    'inactive',
                    'transferred-in',
                    'transferred-out'
                ]),
                startParticipantDate: z.string(),
                endParticipantDate: z.union([
                    z.string(),
                    z.null()
                ])
            })
        })).optional(),
        passes: z.array(z.object({
            id: z.number(),
            gameId: z.number(),
            teamMembershipId: z.number(),
            minute: z.number(),
            teamMembership: z.object({
                id: z.number(),
                tournamentId: z.number(),
                teamId: z.number(),
                playerId: z.number(),
                positionId: z.number(),
                tournamentTeamId: z.number(),
                player: z.object({
                    id: z.number(),
                    firstName: z.string(),
                    lastName: z.string(),
                    middleName: z.union([
                        z.string(),
                        z.null()
                    ]).optional(),
                    dateOfBirth: z.string(),
                    avatarUrl: z.union([
                        z.string(),
                        z.null()
                    ])
                }),
                number: z.number(),
                status: z.enum([
                    'active',
                    'inactive',
                    'transferred-in',
                    'transferred-out'
                ]),
                startParticipantDate: z.string(),
                endParticipantDate: z.union([
                    z.string(),
                    z.null()
                ])
            })
        })).optional()
    })
});

export const zGetGamesStatsResultDto = z.object({
    success: z.boolean(),
    data: z.array(z.object({
        id: z.number(),
        tournamentId: z.number(),
        tourId: z.number(),
        teamOneId: z.union([
            z.number(),
            z.null()
        ]),
        teamTwoId: z.union([
            z.number(),
            z.null()
        ]),
        teamOnePlaceholder: z.string(),
        teamTwoPlaceholder: z.string(),
        teamOneGoals: z.number(),
        teamOnePenaltyGoals: z.number(),
        teamTwoGoals: z.number(),
        teamTwoPenaltyGoals: z.number(),
        isPostponed: z.boolean(),
        isProblematicGame: z.boolean(),
        date: z.union([
            z.string(),
            z.null()
        ]),
        postponementDate: z.union([
            z.string(),
            z.null()
        ]),
        notes: z.string(),
        status: z.enum([
            'default',
            'under-review',
            'finished',
            'canceled'
        ]),
        teamOne: z.union([
            z.object({
                id: z.number(),
                name: z.string(),
                logoUrl: z.union([
                    z.string(),
                    z.null()
                ]),
                foundedYear: z.union([
                    z.number(),
                    z.null()
                ])
            }),
            z.null()
        ]).optional(),
        teamTwo: z.union([
            z.object({
                id: z.number(),
                name: z.string(),
                logoUrl: z.union([
                    z.string(),
                    z.null()
                ]),
                foundedYear: z.union([
                    z.number(),
                    z.null()
                ])
            }),
            z.null()
        ]).optional(),
        referees: z.array(z.object({
            id: z.number(),
            gameId: z.number(),
            refereeId: z.number(),
            referee: z.object({
                id: z.number(),
                firstName: z.string(),
                lastName: z.string(),
                middleName: z.union([
                    z.string(),
                    z.null()
                ]).optional(),
                dateOfBirth: z.string(),
                avatarUrl: z.union([
                    z.string(),
                    z.null()
                ])
            })
        })).optional(),
        goals: z.array(z.object({
            id: z.number(),
            gameId: z.number(),
            teamMembershipId: z.number(),
            teamMembership: z.object({
                id: z.number(),
                tournamentId: z.number(),
                teamId: z.number(),
                playerId: z.number(),
                positionId: z.number(),
                tournamentTeamId: z.number(),
                player: z.object({
                    id: z.number(),
                    firstName: z.string(),
                    lastName: z.string(),
                    middleName: z.union([
                        z.string(),
                        z.null()
                    ]).optional(),
                    dateOfBirth: z.string(),
                    avatarUrl: z.union([
                        z.string(),
                        z.null()
                    ])
                }),
                number: z.number(),
                status: z.enum([
                    'active',
                    'inactive',
                    'transferred-in',
                    'transferred-out'
                ]),
                startParticipantDate: z.string(),
                endParticipantDate: z.union([
                    z.string(),
                    z.null()
                ])
            }),
            minute: z.number(),
            isOwnGoal: z.boolean(),
            isFromPenalty: z.boolean(),
            isFrom10m: z.boolean()
        })).optional(),
        fouls: z.array(z.object({
            id: z.number(),
            gameId: z.number(),
            teamMembershipId: z.number(),
            teamMembership: z.object({
                id: z.number(),
                tournamentId: z.number(),
                teamId: z.number(),
                playerId: z.number(),
                positionId: z.number(),
                tournamentTeamId: z.number(),
                player: z.object({
                    id: z.number(),
                    firstName: z.string(),
                    lastName: z.string(),
                    middleName: z.union([
                        z.string(),
                        z.null()
                    ]).optional(),
                    dateOfBirth: z.string(),
                    avatarUrl: z.union([
                        z.string(),
                        z.null()
                    ])
                }),
                number: z.number(),
                status: z.enum([
                    'active',
                    'inactive',
                    'transferred-in',
                    'transferred-out'
                ]),
                startParticipantDate: z.string(),
                endParticipantDate: z.union([
                    z.string(),
                    z.null()
                ])
            }),
            minute: z.number(),
            reason: z.string().max(80),
            card: z.enum(['yellow', 'red'])
        })).optional(),
        passes: z.array(z.object({
            id: z.number(),
            gameId: z.number(),
            teamMembershipId: z.number(),
            teamMembership: z.object({
                id: z.number(),
                tournamentId: z.number(),
                teamId: z.number(),
                playerId: z.number(),
                positionId: z.number(),
                tournamentTeamId: z.number(),
                player: z.object({
                    id: z.number(),
                    firstName: z.string(),
                    lastName: z.string(),
                    middleName: z.union([
                        z.string(),
                        z.null()
                    ]).optional(),
                    dateOfBirth: z.string(),
                    avatarUrl: z.union([
                        z.string(),
                        z.null()
                    ])
                }),
                number: z.number(),
                status: z.enum([
                    'active',
                    'inactive',
                    'transferred-in',
                    'transferred-out'
                ]),
                startParticipantDate: z.string(),
                endParticipantDate: z.union([
                    z.string(),
                    z.null()
                ])
            }),
            minute: z.number()
        }))
    }))
});

export const zGetGamePublicResultDto = z.object({
    success: z.boolean(),
    data: z.object({
        id: z.number(),
        tournamentId: z.number(),
        tourId: z.number(),
        teamOneId: z.union([
            z.number(),
            z.null()
        ]),
        teamTwoId: z.union([
            z.number(),
            z.null()
        ]),
        teamOnePlaceholder: z.string(),
        teamTwoPlaceholder: z.string(),
        teamOneGoals: z.number(),
        teamOnePenaltyGoals: z.number(),
        teamTwoGoals: z.number(),
        teamTwoPenaltyGoals: z.number(),
        isPostponed: z.boolean(),
        isProblematicGame: z.boolean(),
        date: z.union([
            z.string(),
            z.null()
        ]),
        postponementDate: z.union([
            z.string(),
            z.null()
        ]),
        notes: z.string(),
        status: z.enum([
            'default',
            'under-review',
            'finished',
            'canceled'
        ]),
        tour: z.object({
            id: z.number(),
            name: z.string()
        }),
        teamOne: z.union([
            z.object({
                id: z.number(),
                name: z.string(),
                logoUrl: z.union([
                    z.string(),
                    z.null()
                ]),
                foundedYear: z.union([
                    z.number(),
                    z.null()
                ])
            }),
            z.null()
        ]).optional(),
        teamTwo: z.union([
            z.object({
                id: z.number(),
                name: z.string(),
                logoUrl: z.union([
                    z.string(),
                    z.null()
                ]),
                foundedYear: z.union([
                    z.number(),
                    z.null()
                ])
            }),
            z.null()
        ]).optional(),
        tournament: z.object({
            id: z.number(),
            parentTournamentId: z.union([
                z.number(),
                z.null()
            ]),
            type: z.enum([
                'table',
                'group',
                'cup'
            ]),
            title: z.string(),
            about: z.union([
                z.string(),
                z.null()
            ]).optional(),
            withExtraPointsOnGameDraw: z.boolean(),
            with10mPenalty: z.boolean(),
            photos: z.union([
                z.array(z.object({
                    id: z.number(),
                    tournamentId: z.union([
                        z.number(),
                        z.null()
                    ]),
                    url: z.string(),
                    storageKey: z.string(),
                    createdAt: z.string()
                })),
                z.null()
            ]).optional(),
            publishedAt: z.union([
                z.string(),
                z.null()
            ]),
            startedAt: z.string().optional(),
            archivedAt: z.union([
                z.string(),
                z.null()
            ]),
            parentTournament: z.union([
                z.object({
                    id: z.number(),
                    parentTournamentId: z.union([
                        z.number(),
                        z.null()
                    ]),
                    type: z.enum([
                        'table',
                        'group',
                        'cup'
                    ]),
                    title: z.string(),
                    about: z.union([
                        z.string(),
                        z.null()
                    ]).optional(),
                    withExtraPointsOnGameDraw: z.boolean(),
                    with10mPenalty: z.boolean(),
                    photos: z.union([
                        z.array(z.object({
                            id: z.number(),
                            tournamentId: z.union([
                                z.number(),
                                z.null()
                            ]),
                            url: z.string(),
                            storageKey: z.string(),
                            createdAt: z.string()
                        })),
                        z.null()
                    ]).optional(),
                    publishedAt: z.union([
                        z.string(),
                        z.null()
                    ]),
                    startedAt: z.string().optional(),
                    archivedAt: z.union([
                        z.string(),
                        z.null()
                    ])
                }),
                z.null()
            ]).optional(),
            childrenTournaments: z.union([
                z.array(z.object({
                    id: z.number(),
                    parentTournamentId: z.union([
                        z.number(),
                        z.null()
                    ]),
                    type: z.enum([
                        'table',
                        'group',
                        'cup'
                    ]),
                    title: z.string(),
                    about: z.union([
                        z.string(),
                        z.null()
                    ]).optional(),
                    withExtraPointsOnGameDraw: z.boolean(),
                    with10mPenalty: z.boolean(),
                    photos: z.union([
                        z.array(z.object({
                            id: z.number(),
                            tournamentId: z.union([
                                z.number(),
                                z.null()
                            ]),
                            url: z.string(),
                            storageKey: z.string(),
                            createdAt: z.string()
                        })),
                        z.null()
                    ]).optional(),
                    publishedAt: z.union([
                        z.string(),
                        z.null()
                    ]),
                    startedAt: z.string().optional(),
                    archivedAt: z.union([
                        z.string(),
                        z.null()
                    ])
                })),
                z.null()
            ]).optional()
        }),
        referees: z.array(z.object({
            id: z.number(),
            gameId: z.number(),
            refereeId: z.number(),
            referee: z.object({
                id: z.number(),
                firstName: z.string(),
                lastName: z.string(),
                middleName: z.union([
                    z.string(),
                    z.null()
                ]).optional(),
                dateOfBirth: z.string(),
                avatarUrl: z.union([
                    z.string(),
                    z.null()
                ])
            })
        })).optional(),
        fouls: z.array(z.object({
            id: z.number(),
            gameId: z.number(),
            teamMembershipId: z.number(),
            minute: z.number(),
            reason: z.string(),
            card: z.enum(['yellow', 'red']),
            teamMembership: z.object({
                id: z.number(),
                tournamentId: z.number(),
                teamId: z.number(),
                playerId: z.number(),
                positionId: z.number(),
                tournamentTeamId: z.number(),
                player: z.object({
                    id: z.number(),
                    firstName: z.string(),
                    lastName: z.string(),
                    middleName: z.union([
                        z.string(),
                        z.null()
                    ]).optional(),
                    dateOfBirth: z.string(),
                    avatarUrl: z.union([
                        z.string(),
                        z.null()
                    ])
                }),
                number: z.number(),
                status: z.enum([
                    'active',
                    'inactive',
                    'transferred-in',
                    'transferred-out'
                ]),
                startParticipantDate: z.string(),
                endParticipantDate: z.union([
                    z.string(),
                    z.null()
                ])
            })
        })).optional(),
        goals: z.array(z.object({
            id: z.number(),
            gameId: z.number(),
            teamMembershipId: z.number(),
            minute: z.number(),
            isOwnGoal: z.boolean(),
            isFromPenalty: z.boolean(),
            isFrom10m: z.boolean(),
            teamMembership: z.object({
                id: z.number(),
                tournamentId: z.number(),
                teamId: z.number(),
                playerId: z.number(),
                positionId: z.number(),
                tournamentTeamId: z.number(),
                player: z.object({
                    id: z.number(),
                    firstName: z.string(),
                    lastName: z.string(),
                    middleName: z.union([
                        z.string(),
                        z.null()
                    ]).optional(),
                    dateOfBirth: z.string(),
                    avatarUrl: z.union([
                        z.string(),
                        z.null()
                    ])
                }),
                number: z.number(),
                status: z.enum([
                    'active',
                    'inactive',
                    'transferred-in',
                    'transferred-out'
                ]),
                startParticipantDate: z.string(),
                endParticipantDate: z.union([
                    z.string(),
                    z.null()
                ])
            })
        })).optional(),
        passes: z.array(z.object({
            id: z.number(),
            gameId: z.number(),
            teamMembershipId: z.number(),
            minute: z.number(),
            teamMembership: z.object({
                id: z.number(),
                tournamentId: z.number(),
                teamId: z.number(),
                playerId: z.number(),
                positionId: z.number(),
                tournamentTeamId: z.number(),
                player: z.object({
                    id: z.number(),
                    firstName: z.string(),
                    lastName: z.string(),
                    middleName: z.union([
                        z.string(),
                        z.null()
                    ]).optional(),
                    dateOfBirth: z.string(),
                    avatarUrl: z.union([
                        z.string(),
                        z.null()
                    ])
                }),
                number: z.number(),
                status: z.enum([
                    'active',
                    'inactive',
                    'transferred-in',
                    'transferred-out'
                ]),
                startParticipantDate: z.string(),
                endParticipantDate: z.union([
                    z.string(),
                    z.null()
                ])
            })
        })).optional(),
        participants: z.array(z.object({
            id: z.number(),
            gameId: z.number(),
            teamMembershipId: z.number(),
            teamMembership: z.object({
                id: z.number(),
                tournamentId: z.number(),
                teamId: z.number(),
                playerId: z.number(),
                positionId: z.number(),
                tournamentTeamId: z.number(),
                player: z.object({
                    id: z.number(),
                    firstName: z.string(),
                    lastName: z.string(),
                    middleName: z.union([
                        z.string(),
                        z.null()
                    ]).optional(),
                    dateOfBirth: z.string(),
                    avatarUrl: z.union([
                        z.string(),
                        z.null()
                    ])
                }),
                number: z.number(),
                status: z.enum([
                    'active',
                    'inactive',
                    'transferred-in',
                    'transferred-out'
                ]),
                startParticipantDate: z.string(),
                endParticipantDate: z.union([
                    z.string(),
                    z.null()
                ])
            })
        })).optional()
    })
});

export const zHeadToHeadPaginationResult = z.object({
    success: z.boolean(),
    data: z.object({
        items: z.array(z.object({
            id: z.number(),
            tournamentId: z.number(),
            tourId: z.number(),
            teamOneId: z.union([
                z.number(),
                z.null()
            ]),
            teamTwoId: z.union([
                z.number(),
                z.null()
            ]),
            teamOnePlaceholder: z.string(),
            teamTwoPlaceholder: z.string(),
            teamOneGoals: z.number(),
            teamOnePenaltyGoals: z.number(),
            teamTwoGoals: z.number(),
            teamTwoPenaltyGoals: z.number(),
            isPostponed: z.boolean(),
            isProblematicGame: z.boolean(),
            date: z.union([
                z.string(),
                z.null()
            ]),
            postponementDate: z.union([
                z.string(),
                z.null()
            ]),
            notes: z.string(),
            status: z.enum([
                'default',
                'under-review',
                'finished',
                'canceled'
            ]),
            teamOne: z.union([
                z.object({
                    id: z.number(),
                    name: z.string(),
                    logoUrl: z.union([
                        z.string(),
                        z.null()
                    ]),
                    foundedYear: z.union([
                        z.number(),
                        z.null()
                    ])
                }),
                z.null()
            ]).optional(),
            teamTwo: z.union([
                z.object({
                    id: z.number(),
                    name: z.string(),
                    logoUrl: z.union([
                        z.string(),
                        z.null()
                    ]),
                    foundedYear: z.union([
                        z.number(),
                        z.null()
                    ])
                }),
                z.null()
            ]).optional(),
            tournament: z.object({
                id: z.number(),
                parentTournamentId: z.union([
                    z.number(),
                    z.null()
                ]),
                type: z.enum([
                    'table',
                    'group',
                    'cup'
                ]),
                title: z.string(),
                about: z.union([
                    z.string(),
                    z.null()
                ]).optional(),
                withExtraPointsOnGameDraw: z.boolean(),
                with10mPenalty: z.boolean(),
                photos: z.union([
                    z.array(z.object({
                        id: z.number(),
                        tournamentId: z.union([
                            z.number(),
                            z.null()
                        ]),
                        url: z.string(),
                        storageKey: z.string(),
                        createdAt: z.string()
                    })),
                    z.null()
                ]).optional(),
                publishedAt: z.union([
                    z.string(),
                    z.null()
                ]),
                startedAt: z.string().optional(),
                archivedAt: z.union([
                    z.string(),
                    z.null()
                ]),
                parentTournament: z.union([
                    z.object({
                        id: z.number(),
                        parentTournamentId: z.union([
                            z.number(),
                            z.null()
                        ]),
                        type: z.enum([
                            'table',
                            'group',
                            'cup'
                        ]),
                        title: z.string(),
                        about: z.union([
                            z.string(),
                            z.null()
                        ]).optional(),
                        withExtraPointsOnGameDraw: z.boolean(),
                        with10mPenalty: z.boolean(),
                        photos: z.union([
                            z.array(z.object({
                                id: z.number(),
                                tournamentId: z.union([
                                    z.number(),
                                    z.null()
                                ]),
                                url: z.string(),
                                storageKey: z.string(),
                                createdAt: z.string()
                            })),
                            z.null()
                        ]).optional(),
                        publishedAt: z.union([
                            z.string(),
                            z.null()
                        ]),
                        startedAt: z.string().optional(),
                        archivedAt: z.union([
                            z.string(),
                            z.null()
                        ])
                    }),
                    z.null()
                ]).optional(),
                childrenTournaments: z.union([
                    z.array(z.object({
                        id: z.number(),
                        parentTournamentId: z.union([
                            z.number(),
                            z.null()
                        ]),
                        type: z.enum([
                            'table',
                            'group',
                            'cup'
                        ]),
                        title: z.string(),
                        about: z.union([
                            z.string(),
                            z.null()
                        ]).optional(),
                        withExtraPointsOnGameDraw: z.boolean(),
                        with10mPenalty: z.boolean(),
                        photos: z.union([
                            z.array(z.object({
                                id: z.number(),
                                tournamentId: z.union([
                                    z.number(),
                                    z.null()
                                ]),
                                url: z.string(),
                                storageKey: z.string(),
                                createdAt: z.string()
                            })),
                            z.null()
                        ]).optional(),
                        publishedAt: z.union([
                            z.string(),
                            z.null()
                        ]),
                        startedAt: z.string().optional(),
                        archivedAt: z.union([
                            z.string(),
                            z.null()
                        ])
                    })),
                    z.null()
                ]).optional()
            })
        })),
        page: z.object({
            total: z.number(),
            skip: z.number(),
            limit: z.number()
        }),
        gameId: z.number(),
        teamOneId: z.number(),
        teamTwoId: z.number()
    })
});

export const zToursResultDto = z.object({
    success: z.boolean(),
    data: z.array(z.object({
        id: z.number(),
        tourTypeId: z.number(),
        order: z.number(),
        tourType: z.object({
            id: z.number(),
            name: z.string()
        }),
        tournament: z.object({
            id: z.number(),
            parentTournamentId: z.union([
                z.number(),
                z.null()
            ]),
            type: z.enum([
                'table',
                'group',
                'cup'
            ]),
            title: z.string(),
            about: z.union([
                z.string(),
                z.null()
            ]).optional(),
            withExtraPointsOnGameDraw: z.boolean(),
            with10mPenalty: z.boolean(),
            photos: z.union([
                z.array(z.object({
                    id: z.number(),
                    tournamentId: z.union([
                        z.number(),
                        z.null()
                    ]),
                    url: z.string(),
                    storageKey: z.string(),
                    createdAt: z.string()
                })),
                z.null()
            ]).optional(),
            publishedAt: z.union([
                z.string(),
                z.null()
            ]),
            startedAt: z.string().optional(),
            archivedAt: z.union([
                z.string(),
                z.null()
            ]),
            parentTournament: z.union([
                z.object({
                    id: z.number(),
                    parentTournamentId: z.union([
                        z.number(),
                        z.null()
                    ]),
                    type: z.enum([
                        'table',
                        'group',
                        'cup'
                    ]),
                    title: z.string(),
                    about: z.union([
                        z.string(),
                        z.null()
                    ]).optional(),
                    withExtraPointsOnGameDraw: z.boolean(),
                    with10mPenalty: z.boolean(),
                    photos: z.union([
                        z.array(z.object({
                            id: z.number(),
                            tournamentId: z.union([
                                z.number(),
                                z.null()
                            ]),
                            url: z.string(),
                            storageKey: z.string(),
                            createdAt: z.string()
                        })),
                        z.null()
                    ]).optional(),
                    publishedAt: z.union([
                        z.string(),
                        z.null()
                    ]),
                    startedAt: z.string().optional(),
                    archivedAt: z.union([
                        z.string(),
                        z.null()
                    ])
                }),
                z.null()
            ]).optional(),
            childrenTournaments: z.union([
                z.array(z.object({
                    id: z.number(),
                    parentTournamentId: z.union([
                        z.number(),
                        z.null()
                    ]),
                    type: z.enum([
                        'table',
                        'group',
                        'cup'
                    ]),
                    title: z.string(),
                    about: z.union([
                        z.string(),
                        z.null()
                    ]).optional(),
                    withExtraPointsOnGameDraw: z.boolean(),
                    with10mPenalty: z.boolean(),
                    photos: z.union([
                        z.array(z.object({
                            id: z.number(),
                            tournamentId: z.union([
                                z.number(),
                                z.null()
                            ]),
                            url: z.string(),
                            storageKey: z.string(),
                            createdAt: z.string()
                        })),
                        z.null()
                    ]).optional(),
                    publishedAt: z.union([
                        z.string(),
                        z.null()
                    ]),
                    startedAt: z.string().optional(),
                    archivedAt: z.union([
                        z.string(),
                        z.null()
                    ])
                })),
                z.null()
            ]).optional()
        }),
        group: z.object({
            id: z.number(),
            name: z.string()
        }),
        tournamentId: z.number(),
        groupId: z.number().optional()
    }))
});

export const zCreateTourDto = z.object({
    tourTypeId: z.number(),
    tournamentId: z.number(),
    groupId: z.number().optional()
});

export const zUpdateTourDto = z.object({
    tourTypeId: z.number().optional(),
    tournamentId: z.number().optional(),
    groupId: z.number().optional()
});

export const zGetUploadUrlDto = z.object({
    fileName: z.string(),
    path: z.string()
});

export const zGetUploadUrlResult = z.object({
    success: z.boolean(),
    data: z.object({
        uploadUrl: z.string(),
        objectKey: z.string()
    })
});

export const zPlayerPositionControllerFindAllData = z.object({
    body: z.never().optional(),
    path: z.never().optional(),
    query: z.object({
        query: z.string().optional(),
        sort: z.record(z.string()).default({}),
        skip: z.number().gte(0).optional(),
        limit: z.number().gte(1).optional()
    })
});

export const zPlayerPositionControllerFindAllResponse = zPaginationPlayerPositionResult;

export const zPlayerPositionControllerCreateData = z.object({
    body: zCreatePlayerPositionDto,
    path: z.never().optional(),
    query: z.never().optional()
});

export const zPlayerPositionControllerCreateResponse = zUpdateResultDto;

export const zPlayerPositionControllerRemoveData = z.object({
    body: z.never().optional(),
    path: z.object({
        id: z.string()
    }),
    query: z.never().optional()
});

export const zPlayerPositionControllerRemoveResponse = zUpdateResultDto;

export const zPlayerPositionControllerFindOneData = z.object({
    body: z.never().optional(),
    path: z.object({
        id: z.number()
    }),
    query: z.never().optional()
});

export const zPlayerPositionControllerFindOneResponse = zPlayerPositionResultDto;

export const zPlayerPositionControllerUpdateData = z.object({
    body: zCreatePlayerPositionDto,
    path: z.object({
        id: z.string()
    }),
    query: z.never().optional()
});

export const zPlayerPositionControllerUpdateResponse = zUpdateResultDto;

export const zAuthActionControllerFindAllData = z.object({
    body: z.never().optional(),
    path: z.never().optional(),
    query: z.object({
        query: z.string().optional(),
        sort: z.record(z.string()).default({}),
        skip: z.number().gte(0).optional(),
        limit: z.number().gte(1).optional()
    })
});

export const zAuthActionControllerFindAllResponse = zInvitesPaginationResult;

export const zAuthActionControllerCreateData = z.object({
    body: zCreateInviteDto,
    path: z.never().optional(),
    query: z.never().optional()
});

export const zAuthActionControllerCreateResponse = zUpdateResultDto;

export const zAuthActionControllerGetInviteData = z.object({
    body: z.never().optional(),
    path: z.object({
        id: z.number()
    }),
    query: z.never().optional()
});

export const zAuthActionControllerGetInviteResponse = zGetInviteResultDto;

export const zAuthActionControllerGetQrCodeData = z.object({
    body: z.never().optional(),
    path: z.object({
        id: z.number()
    }),
    query: z.never().optional()
});

export const zAuthActionControllerGetQrCodeResponse = zGetQrCodeResultDto;

export const zAuthActionControllerCompleteInviteData = z.object({
    body: zInviteCompleteDto,
    path: z.object({
        id: z.number()
    }),
    query: z.never().optional()
});

export const zAuthActionControllerCompleteInviteResponse = zUpdateResultDto;

export const zAuthActionControllerRemoveData = z.object({
    body: z.never().optional(),
    path: z.object({
        id: z.number()
    }),
    query: z.never().optional()
});

export const zAuthActionControllerRemoveResponse = zUpdateResultDto;

export const zTournamentControllerFindAllData = z.object({
    body: z.never().optional(),
    path: z.never().optional(),
    query: z.object({
        query: z.string().optional(),
        sort: z.record(z.string()).default({}),
        skip: z.number().gte(0).optional(),
        limit: z.number().gte(1).optional(),
        withInnerTournaments: z.boolean().optional()
    })
});

export const zTournamentControllerFindAllResponse = zPaginationTournamentResultDto;

export const zTournamentControllerCreateData = z.object({
    body: zCreateTournamentDto,
    path: z.never().optional(),
    query: z.never().optional()
});

export const zTournamentControllerCreateResponse = zUpdateResultDto;

export const zTournamentControllerDeleteData = z.object({
    body: z.never().optional(),
    path: z.object({
        id: z.number()
    }),
    query: z.never().optional()
});

export const zTournamentControllerDeleteResponse = zUpdateResultDto;

export const zTournamentControllerFindOneData = z.object({
    body: z.never().optional(),
    path: z.object({
        id: z.number()
    }),
    query: z.never().optional()
});

export const zTournamentControllerFindOneResponse = zTournamentWithAwardsResultDto;

export const zTournamentControllerUpdateData = z.object({
    body: zUpdateTournamentDto,
    path: z.object({
        id: z.number()
    }),
    query: z.never().optional()
});

export const zTournamentControllerUpdateResponse = zUpdateResultDto;

export const zTournamentControllerUpdatePhotosData = z.object({
    body: zUpdateTournamentPhotosSchemaDto,
    path: z.object({
        id: z.number()
    }),
    query: z.never().optional()
});

export const zTournamentControllerUpdatePhotosResponse = zUpdateResultDto;

export const zTournamentControllerFindOnePublicData = z.object({
    body: z.never().optional(),
    path: z.object({
        id: z.number()
    }),
    query: z.never().optional()
});

export const zTournamentControllerFindOnePublicResponse = zTournamentWithAwardsResultDto;

export const zTournamentControllerGetTournamentTeamsData = z.object({
    body: z.never().optional(),
    path: z.object({
        id: z.number()
    }),
    query: z.never().optional()
});

export const zTournamentControllerGetTournamentTeamsResponse = zTournamentTeamsResultDto;

export const zTournamentControllerGetTournamentParticipantsData = z.object({
    body: z.never().optional(),
    path: z.object({
        id: z.number()
    }),
    query: z.never().optional()
});

export const zTournamentControllerGetTournamentParticipantsResponse = zTournamentParticipantsResultDto;

export const zTournamentControllerGetTournamentStandingsData = z.object({
    body: z.never().optional(),
    path: z.object({
        id: z.number()
    }),
    query: z.never().optional()
});

export const zTournamentControllerGetTournamentStandingsResponse = zTournamentStandingsResultDto;

export const zTournamentControllerGetTournamentMediaData = z.object({
    body: z.never().optional(),
    path: z.object({
        id: z.number()
    }),
    query: z.never().optional()
});

export const zTournamentControllerGetTournamentMediaResponse = zTournamentMediaResultDto;

export const zTournamentControllerSyncWithParentTournamentData = z.object({
    body: zSyncWithParentTournamentDto,
    path: z.object({
        id: z.number()
    }),
    query: z.never().optional()
});

export const zTournamentControllerSyncWithParentTournamentResponse = zUpdateResultDto;

export const zTournamentControllerUpdateResultsData = z.object({
    body: zUpdateTournamentResultsDto,
    path: z.object({
        id: z.number()
    }),
    query: z.never().optional()
});

export const zTournamentControllerUpdateResultsResponse = zUpdateResultDto;

export const zTournamentControllerAddTeamData = z.object({
    body: z.object({
        teamId: z.number(),
        groupId: z.number().optional(),
        photo: z.any().optional(),
        extraPoints: z.number()
    }),
    path: z.object({
        tournamentId: z.number()
    }),
    query: z.never().optional()
});

export const zTournamentControllerAddTeamResponse = zUpdateResultDto;

export const zTournamentControllerDeleteTeamData = z.object({
    body: z.never().optional(),
    path: z.object({
        tournamentId: z.number(),
        tournamentTeamId: z.number()
    }),
    query: z.never().optional()
});

export const zTournamentControllerDeleteTeamResponse = zUpdateResultDto;

export const zTournamentControllerUpdateTeamData = z.object({
    body: z.object({
        teamId: z.number().optional(),
        groupId: z.number().optional(),
        photo: z.any().optional(),
        extraPoints: z.number().optional(),
        photoUrl: z.string().optional()
    }),
    path: z.object({
        tournamentId: z.number(),
        tournamentTeamId: z.number()
    }),
    query: z.never().optional()
});

export const zTournamentControllerUpdateTeamResponse = zUpdateResultDto;

export const zTournamentControllerChangeTeamsOrderData = z.object({
    body: zChangeTournamentTeamsOrderSchemaDto,
    path: z.object({
        tournamentId: z.number()
    }),
    query: z.never().optional()
});

export const zTournamentControllerChangeTeamsOrderResponse = zUpdateResultDto;

export const zTeamMembershipControllerImportTeamMembershipData = z.object({
    body: zImportTeamMembershipDto,
    path: z.never().optional(),
    query: z.never().optional()
});

export const zTeamMembershipControllerImportTeamMembershipResponse = zUpdateResultDto;

export const zTeamMembershipControllerGetTeamMembershipData = z.object({
    body: z.never().optional(),
    path: z.never().optional(),
    query: z.object({
        tournamentId: z.number(),
        teamId: z.number(),
        onlyActive: z.boolean().optional().default(false)
    })
});

export const zTeamMembershipControllerGetTeamMembershipResponse = zGetTeamMembershipResult;

export const zTeamMembershipControllerAddTeamMembershipData = z.object({
    body: zAddTeamMembershipDto,
    path: z.never().optional(),
    query: z.never().optional()
});

export const zTeamMembershipControllerAddTeamMembershipResponse = zUpdateResultDto;

export const zTeamMembershipControllerDeleteData = z.object({
    body: z.never().optional(),
    path: z.object({
        id: z.number()
    }),
    query: z.never().optional()
});

export const zTeamMembershipControllerDeleteResponse = zUpdateResultDto;

export const zTeamMembershipControllerUpdateTeamMembershipData = z.object({
    body: zAddTeamMembershipDto,
    path: z.object({
        id: z.number()
    }),
    query: z.never().optional()
});

export const zTeamMembershipControllerUpdateTeamMembershipResponse = zUpdateResultDto;

export const zTeamMembershipControllerGetTeamMembershipByIdsData = z.object({
    body: z.never().optional(),
    path: z.never().optional(),
    query: z.object({
        ids: z.array(z.number())
    })
});

export const zTeamMembershipControllerGetTeamMembershipByIdsResponse = zGetTeamMembershipResult;

export const zTourTypeControllerFindAllData = z.object({
    body: z.never().optional(),
    path: z.never().optional(),
    query: z.object({
        query: z.string().optional(),
        sort: z.record(z.string()).default({}),
        skip: z.number().gte(0).optional(),
        limit: z.number().gte(1).optional()
    })
});

export const zTourTypeControllerFindAllResponse = zTourTypesPaginationResult;

export const zTourTypeControllerCreateData = z.object({
    body: zCreateTourTypeDto,
    path: z.never().optional(),
    query: z.never().optional()
});

export const zTourTypeControllerCreateResponse = zUpdateResultDto;

export const zTourTypeControllerRemoveData = z.object({
    body: z.never().optional(),
    path: z.object({
        id: z.string()
    }),
    query: z.never().optional()
});

export const zTourTypeControllerRemoveResponse = zUpdateResultDto;

export const zTourTypeControllerFindOneData = z.object({
    body: z.never().optional(),
    path: z.object({
        id: z.string()
    }),
    query: z.never().optional()
});

export const zTourTypeControllerFindOneResponse = zTourTypeResultDto;

export const zTourTypeControllerUpdateData = z.object({
    body: zUpdateTourTypeDto,
    path: z.object({
        id: z.string()
    }),
    query: z.never().optional()
});

export const zTourTypeControllerUpdateResponse = zUpdateResultDto;

export const zRefereeControllerFindAllData = z.object({
    body: z.never().optional(),
    path: z.never().optional(),
    query: z.object({
        query: z.string().optional(),
        sort: z.record(z.string()).default({}),
        skip: z.number().gte(0).optional(),
        limit: z.number().gte(1).optional()
    })
});

export const zRefereeControllerFindAllResponse = zRefereesPaginationResult;

export const zRefereeControllerCreateData = z.object({
    body: z.object({
        firstName: z.string(),
        lastName: z.string(),
        middleName: z.string().optional(),
        dateOfBirth: z.string(),
        avatar: z.any().optional()
    }),
    path: z.never().optional(),
    query: z.never().optional()
});

export const zRefereeControllerCreateResponse = zUpdateResultDto;

export const zRefereeControllerFindAllPublicData = z.object({
    body: z.never().optional(),
    path: z.never().optional(),
    query: z.object({
        query: z.string().optional(),
        sort: z.record(z.string()).default({}),
        skip: z.number().gte(0).optional(),
        limit: z.number().gte(1).optional()
    })
});

export const zRefereeControllerFindAllPublicResponse = zWebsiteRefereesPaginationResult;

export const zRefereeControllerRemoveData = z.object({
    body: z.never().optional(),
    path: z.object({
        id: z.string()
    }),
    query: z.never().optional()
});

export const zRefereeControllerRemoveResponse = zUpdateResultDto;

export const zRefereeControllerFindOneData = z.object({
    body: z.never().optional(),
    path: z.object({
        id: z.string()
    }),
    query: z.never().optional()
});

export const zRefereeControllerFindOneResponse = zRefereeResultDto;

export const zRefereeControllerUpdateData = z.object({
    body: z.object({
        firstName: z.string().optional(),
        lastName: z.string().optional(),
        middleName: z.string().optional(),
        dateOfBirth: z.string().optional(),
        avatar: z.any().optional(),
        avatarUrl: z.string().optional()
    }),
    path: z.object({
        id: z.string()
    }),
    query: z.never().optional()
});

export const zRefereeControllerUpdateResponse = zUpdateResultDto;

export const zPlayerControllerFindAllData = z.object({
    body: z.never().optional(),
    path: z.never().optional(),
    query: z.object({
        query: z.string().optional(),
        sort: z.record(z.string()).default({}),
        skip: z.number().gte(0).optional(),
        limit: z.number().gte(1).optional()
    })
});

export const zPlayerControllerFindAllResponse = zPlayersPaginationResult;

export const zPlayerControllerCreateData = z.object({
    body: z.object({
        firstName: z.string(),
        lastName: z.string(),
        middleName: z.string().optional(),
        dateOfBirth: z.string(),
        avatar: z.any().optional()
    }),
    path: z.never().optional(),
    query: z.never().optional()
});

export const zPlayerControllerCreateResponse = zUpdateResultDto;

export const zPlayerControllerFindAllPublicData = z.object({
    body: z.never().optional(),
    path: z.never().optional(),
    query: z.object({
        query: z.string().optional(),
        sort: z.record(z.string()).default({}),
        skip: z.number().gte(0).optional(),
        limit: z.number().gte(1).optional()
    })
});

export const zPlayerControllerFindAllPublicResponse = zWebsitePlayersPaginationResult;

export const zPlayerControllerFindOnePublicData = z.object({
    body: z.never().optional(),
    path: z.object({
        id: z.number()
    }),
    query: z.never().optional()
});

export const zPlayerControllerFindOnePublicResponse = zPlayerWithMembershipResultDto;

export const zPlayerControllerRemoveData = z.object({
    body: z.never().optional(),
    path: z.object({
        id: z.string()
    }),
    query: z.never().optional()
});

export const zPlayerControllerRemoveResponse = zUpdateResultDto;

export const zPlayerControllerFindOneData = z.object({
    body: z.never().optional(),
    path: z.object({
        id: z.number()
    }),
    query: z.never().optional()
});

export const zPlayerControllerFindOneResponse = zPlayerResultDto;

export const zPlayerControllerUpdateData = z.object({
    body: z.object({
        firstName: z.string().optional(),
        lastName: z.string().optional(),
        middleName: z.string().optional(),
        dateOfBirth: z.string().optional(),
        avatar: z.any().optional(),
        avatarUrl: z.string().optional()
    }),
    path: z.object({
        id: z.string()
    }),
    query: z.never().optional()
});

export const zPlayerControllerUpdateResponse = zUpdateResultDto;

export const zGroupControllerFindAllData = z.object({
    body: z.never().optional(),
    path: z.never().optional(),
    query: z.object({
        query: z.string().optional(),
        sort: z.record(z.string()).default({}),
        skip: z.number().gte(0).optional(),
        limit: z.number().gte(1).optional()
    })
});

export const zGroupControllerFindAllResponse = zPaginationResult;

export const zGroupControllerCreateData = z.object({
    body: zCreateGroupDto,
    path: z.never().optional(),
    query: z.never().optional()
});

export const zGroupControllerCreateResponse = zUpdateResultDto;

export const zGroupControllerRemoveData = z.object({
    body: z.never().optional(),
    path: z.object({
        id: z.string()
    }),
    query: z.never().optional()
});

export const zGroupControllerRemoveResponse = zUpdateResultDto;

export const zGroupControllerFindOneData = z.object({
    body: z.never().optional(),
    path: z.object({
        id: z.string()
    }),
    query: z.never().optional()
});

export const zGroupControllerFindOneResponse = zGroupResultDto;

export const zGroupControllerUpdateData = z.object({
    body: zCreateGroupDto,
    path: z.object({
        id: z.string()
    }),
    query: z.never().optional()
});

export const zGroupControllerUpdateResponse = zUpdateResultDto;

export const zUserControllerMeData = z.object({
    body: z.never().optional(),
    path: z.never().optional(),
    query: z.never().optional()
});

export const zUserControllerMeResponse = zGetUserResultResult;

export const zUserControllerFindAllData = z.object({
    body: z.never().optional(),
    path: z.never().optional(),
    query: z.object({
        query: z.string().optional(),
        sort: z.record(z.string()).default({}),
        skip: z.number().gte(0).optional(),
        limit: z.number().gte(1).optional()
    })
});

export const zUserControllerFindAllResponse = zUsersPaginationResult;

export const zUserControllerRemoveData = z.object({
    body: z.never().optional(),
    path: z.object({
        id: z.string()
    }),
    query: z.never().optional()
});

export const zUserControllerRemoveResponse = zUpdateResultDto;

export const zUserControllerFindOneData = z.object({
    body: z.never().optional(),
    path: z.object({
        id: z.string()
    }),
    query: z.never().optional()
});

export const zUserControllerFindOneResponse = zGetUserResultResult;

export const zUserControllerUpdateData = z.object({
    body: z.object({
        firstName: z.string().optional(),
        lastName: z.string().optional(),
        role: z.enum([
            'DEVELOPER',
            'EDITOR',
            'ADMIN'
        ]).optional(),
        scope: z.string().optional(),
        avatarUrl: z.string().optional(),
        avatar: z.any().optional()
    }),
    path: z.object({
        id: z.string()
    }),
    query: z.never().optional()
});

export const zUserControllerUpdateResponse = zUpdateResultDto;

export const zAuthControllerLoginData = z.object({
    body: zLoginDto,
    path: z.never().optional(),
    query: z.never().optional()
});

export const zAuthControllerLoginResponse = zLoginResponseDto;

export const zAuthControllerRefreshTokenData = z.object({
    body: z.never().optional(),
    path: z.never().optional(),
    query: z.never().optional()
});

export const zAuthControllerLogoutData = z.object({
    body: z.never().optional(),
    path: z.never().optional(),
    query: z.never().optional()
});

export const zAuthControllerLogoutResponse = zUpdateResultDto;

export const zAuthControllerGoogleLoginData = z.object({
    body: z.never().optional(),
    path: z.never().optional(),
    query: z.never().optional()
});

export const zAuthControllerGoogleCallbackData = z.object({
    body: z.never().optional(),
    path: z.never().optional(),
    query: z.never().optional()
});

export const zTeamControllerFindAllData = z.object({
    body: z.never().optional(),
    path: z.never().optional(),
    query: z.object({
        query: z.string().optional(),
        sort: z.record(z.string()).default({}),
        skip: z.number().gte(0).optional(),
        limit: z.number().gte(1).optional()
    })
});

export const zTeamControllerFindAllResponse = zTeamsPaginationResult;

export const zTeamControllerCreateData = z.object({
    body: z.object({
        name: z.string(),
        foundedYear: z.number().optional(),
        logo: z.any().optional()
    }),
    path: z.never().optional(),
    query: z.never().optional()
});

export const zTeamControllerCreateResponse = zUpdateResultDto;

export const zTeamControllerFindAllPublicData = z.object({
    body: z.never().optional(),
    path: z.never().optional(),
    query: z.object({
        query: z.string().optional(),
        sort: z.record(z.string()).default({}),
        skip: z.number().gte(0).optional(),
        limit: z.number().gte(1).optional()
    })
});

export const zTeamControllerFindAllPublicResponse = zTeamsPaginationResult;

export const zTeamControllerFindOnePublicData = z.object({
    body: z.never().optional(),
    path: z.object({
        id: z.number()
    }),
    query: z.never().optional()
});

export const zTeamControllerFindOnePublicResponse = zWebsiteTeamResultDto;

export const zTeamControllerGetTeamTournamentStatsData = z.object({
    body: z.never().optional(),
    path: z.object({
        id: z.number(),
        tournamentId: z.number()
    }),
    query: z.never().optional()
});

export const zTeamControllerGetTeamTournamentStatsResponse = zTeamStatsByTournamentDto;

export const zTeamControllerRemoveData = z.object({
    body: z.never().optional(),
    path: z.object({
        id: z.string()
    }),
    query: z.never().optional()
});

export const zTeamControllerRemoveResponse = zUpdateResultDto;

export const zTeamControllerFindOneData = z.object({
    body: z.never().optional(),
    path: z.object({
        id: z.number()
    }),
    query: z.never().optional()
});

export const zTeamControllerFindOneResponse = zTeamResultDto;

export const zTeamControllerUpdateData = z.object({
    body: z.object({
        name: z.string().optional(),
        foundedYear: z.number().optional(),
        logo: z.any().optional(),
        logoUrl: z.string().optional()
    }),
    path: z.object({
        id: z.string()
    }),
    query: z.never().optional()
});

export const zTeamControllerUpdateResponse = zUpdateResultDto;

export const zGameControllerGetGamesData = z.object({
    body: z.never().optional(),
    path: z.never().optional(),
    query: z.object({
        tournamentId: z.number().gt(0),
        onlyNew: z.boolean().optional()
    })
});

export const zGameControllerGetGamesResponse = zGetGamesResultDto;

export const zGameControllerCreateData = z.object({
    body: zCreateGameDto,
    path: z.never().optional(),
    query: z.never().optional()
});

export const zGameControllerCreateResponse = zUpdateResultDto;

export const zGameControllerRemoveData = z.object({
    body: z.never().optional(),
    path: z.object({
        id: z.string()
    }),
    query: z.never().optional()
});

export const zGameControllerRemoveResponse = zUpdateResultDto;

export const zGameControllerGetGameData = z.object({
    body: z.never().optional(),
    path: z.object({
        id: z.string()
    }),
    query: z.never().optional()
});

export const zGameControllerGetGameResponse = zGetGameResultDto;

export const zGameControllerUpdateData = z.object({
    body: zCreateGameDto,
    path: z.object({
        id: z.string()
    }),
    query: z.never().optional()
});

export const zGameControllerUpdateResponse = zUpdateResultDto;

export const zGameControllerGetGameProtocolData = z.object({
    body: z.never().optional(),
    path: z.object({
        id: z.number()
    }),
    query: z.never().optional()
});

/**
 * PDF details of the game
 */
export const zGameControllerGetGameProtocolResponse = z.any();

export const zGameControllerGetGamesPublicData = z.object({
    body: z.never().optional(),
    path: z.never().optional(),
    query: z.object({
        tournamentId: z.number().gt(0),
        onlyNew: z.boolean().optional()
    })
});

export const zGameControllerGetGamesPublicResponse = zGetGamesResultDto;

export const zGameControllerGetGamesStatisticsData = z.object({
    body: z.never().optional(),
    path: z.never().optional(),
    query: z.object({
        tournamentId: z.number().gt(0),
        onlyNew: z.boolean().optional()
    })
});

export const zGameControllerGetGamesStatisticsResponse = zGetGamesStatsResultDto;

export const zGameControllerGetGamePublicData = z.object({
    body: z.never().optional(),
    path: z.object({
        id: z.number()
    }),
    query: z.never().optional()
});

export const zGameControllerGetGamePublicResponse = zGetGamePublicResultDto;

export const zGameControllerGetHeadToHeadData = z.object({
    body: z.never().optional(),
    path: z.object({
        id: z.number()
    }),
    query: z.object({
        query: z.string().optional(),
        sort: z.record(z.string()).default({}),
        skip: z.number().gte(0).optional(),
        limit: z.number().gte(1).optional()
    })
});

export const zGameControllerGetHeadToHeadResponse = zHeadToHeadPaginationResult;

export const zTourControllerGetToursData = z.object({
    body: z.never().optional(),
    path: z.never().optional(),
    query: z.object({
        tournamentId: z.number()
    })
});

export const zTourControllerGetToursResponse = zToursResultDto;

export const zTourControllerCreateData = z.object({
    body: zCreateTourDto,
    path: z.never().optional(),
    query: z.never().optional()
});

export const zTourControllerCreateResponse = zUpdateResultDto;

export const zTourControllerUpdateData = z.object({
    body: zUpdateTourDto,
    path: z.object({
        id: z.string()
    }),
    query: z.never().optional()
});

export const zTourControllerUpdateResponse = zUpdateResultDto;

export const zAssetsControllerGetUploadUrlData = z.object({
    body: zGetUploadUrlDto,
    path: z.never().optional(),
    query: z.never().optional()
});

export const zAssetsControllerGetUploadUrlResponse = zGetUploadUrlResult;
